/**
 * Reia — Lazy-load shimmer gating
 *
 * The base theme gives every not-yet-loaded image wrapper (.animation--lazy-load)
 * an infinite shimmer animation. Wrappers far below the fold never load until
 * scrolled to, so their shimmer ran forever and kept the browser re-rendering
 * the page every frame while idle (measured ~1.3s main-thread per 10s idle).
 *
 * reia-head-styles.liquid pauses the shimmer by default; this script resumes it
 * only while a wrapper is actually on screen (.reia-shimmer-active).
 */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.add('reia-shimmer-all');
    return;
  }

  var observed = new WeakSet();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var el = entry.target;
      if (el.classList.contains('loaded')) {
        el.classList.remove('reia-shimmer-active');
        io.unobserve(el);
        return;
      }
      el.classList.toggle('reia-shimmer-active', entry.isIntersecting);
    });
  });

  function scan() {
    var els = document.querySelectorAll('.animation--lazy-load:not(.loaded)');
    for (var i = 0; i < els.length; i++) {
      if (!observed.has(els[i])) {
        observed.add(els[i]);
        io.observe(els[i]);
      }
    }
  }

  scan();

  // Pick up wrappers added later (quick view, filtered product grids, drawers).
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      scan();
    }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
